<template>
  <div class="page">
    <Breadcrumb routeName="DestinationList" toName="目的地设置" goPathName="目的地"></Breadcrumb>
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="目的地名称" prop="hotDestinationName">
          <a-input v-model="ruleForm.hotDestinationName" :maxLength="6" placeholder="不超过6个字"/>
        </a-form-model-item>
        <a-form-model-item label="关联目的地" required>
          <a-select allowClear
                    v-model="ruleForm.hotWithinOrOuter"
                    placeholder="请选择"
                    style="max-width:400px;"
          >
            <a-select-option :value="1">国内</a-select-option>
            <a-select-option :value="2">国外</a-select-option>
          </a-select>
        </a-form-model-item>
        <template v-if="ruleForm.hotWithinOrOuter==1">
          <a-form-item label="国内目的地" style="margin-bottom:0;">
            <a-cascader
              style="max-width: 330px;"
              :options="provinceList"
              @change="onCityChange"
              :value='defaultCityValue'
              :showSearch="{ filter }"
              changeOnSelect
              placeholder="国内目的地"
            />
            <a-button style="margin-left:7px;" @click="addproProvinceCity">添加</a-button>
          </a-form-item>
          <a-form-item :wrapper-col="currentFormLayout.offsetCol">
            <template v-if="ruleForm.domesticCityList.length>0">
              <div class="tabs-list">
                <span class="tabs" v-for="(item,index) in ruleForm.domesticCityList" :key="index">
                  <span v-if="item.containCountyName">{{ item.containCountyName }}</span>
                  <span v-else-if="item.containCityName!=''">{{ item.containCityName }}</span>
                  <span v-else>{{ item.containProvinceName }}</span>
                  <a-icon type="close" @click="deleteProvinceCity(item)"/>
                </span>
              </div>
            </template>
          </a-form-item>
        </template>
        <template v-if="ruleForm.hotWithinOrOuter==2">
          <a-form-item label="国外目的地" style="margin-bottom:0;">
            <a-cascader
              style="max-width: 330px;"
              :options="foreignCityList"
              @change="onForeignCityChange"
              :value='defaultForeignCityValue'
              :showSearch="{ filter }"
              changeOnSelect
              placeholder="国外目的地"
            />
            <a-button style="margin-left:7px;" @click="addproForeignCity">添加</a-button>
          </a-form-item>
          <a-form-item :wrapper-col="currentFormLayout.offsetCol">
            <template v-if="ruleForm.foreignCityList.length>0">
              <div class="tabs-list">
                <span class="tabs" v-for="(item,index) in ruleForm.foreignCityList" :key="index">
                  <span v-if="item.containCityName!=''">{{ item.containCityName }}</span>
                  <span v-else>{{ item.containCountryName }}</span>
                  <a-icon type="close" @click="deleteCountryCity(item)"/>
                </span>
              </div>
            </template>
          </a-form-item>
        </template>
        <a-form-model-item label="排序" prop="hotSort">
          <a-input v-model="ruleForm.hotSort" :maxLength="4" placeholder="1-1000"/>
        </a-form-model-item>
        <a-form-model-item label="是否推荐">
          <a-radio-group name="radioGroup" v-model="ruleForm.hotIsHotPush">
            <a-radio :value="0">否</a-radio>
            <a-radio :value="1">是</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group name="radioGroup" v-model="ruleForm.hotStatus">
            <a-radio :value="1">显示</a-radio>
            <a-radio :value="0">隐藏</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="onSubmit" :loading="submitLoading">保存设置</a-button>
          <a-button @click="backEvent" style="margin-left: 10px">返回</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import formMixins from '../../../utils/mixins/formMixins'
import { mapState } from 'vuex'

export default {
  name: 'AddDestination',
  mixins: [formMixins],
  components: {
    Breadcrumb
  },
  data() {
    var checkHotSort = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(this.ruleForm.hotSort) > 1000) {
          callback(new Error('1-1000'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      defaultCityValue: [],
      defaultForeignCityValue: [],
      submitLoading: false,
      provinceList: [],
      hotId: this.$route.query.hotId,
      ruleForm: {
        hotDestinationName: '',
        hotIsHotPush: 1,//是否热推 0普通 1热推 ,
        hotWithinOrOuter: 1,//1 国内 2 国外
        hotId: this.$route.query.hotId,
        foreignCityList: [],//国家城市集合
        domesticCityList: [],//省市城市集合
        hotSort: '',//排序
        hotStatus: 1
      },
      rules: {
        hotDestinationName: [
          { required: true, message: '请输入热门目的地', trigger: 'blur' }
        ],
        hotSort: [
          { required: true, message: '请输入排序值', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,4}$/, message: '请输入正确的数字', trigger: 'blur' },
          { validator: checkHotSort, trigger: 'blur' }
        ]
      },
      currentFormLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 22 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 2 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      cityList: {
        cityId: 0,
        cityName: '',
        countryId: 0,
        countryName: '',
        provinceId: 0,
        provinceName: '',
        countyId: 0,//区域id
        countyName: '',//区域名称
        hotId: Number(this.$route.query.hotId)
      },
      submitFormData: ''
    }
  },
  computed: {
    ...mapState({
      foreignCityList: state => state.user.foreignCityList
    })
  },
  mounted() {

  },
  // 缓存数据
  activated() {
    this.getNewData()
  },
  methods: {
    getNewData() {
      this.hotId = this.$route.query.hotId
      this.cityList.hotId = Number(this.hotId)
      this.getDesDetails()
      this.getProvinceList()
      // this.getForeignCity();
    },
    getProvinceList() {
      this.getHttpServices().getBaseService().get('province/getProvinceCityCounty').then(res => {
        this.provinceList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getForeignCity() {
      // this.getHttpServices().getBaseService().get('province/getForeignCity').then(res=>{
      //  this.foreignCityList=res;
      // }).catch(reason=>this.showNetWorkErrorMessage(reason))
    },
    onCityChange(value, selectedOptions) {
      this.getLogUtils().logWithTag('onCityChange==value', value)
      this.getLogUtils().logWithTag('onCityChange==selectedOptions', selectedOptions)
      if (value && value.length) {
        this.cityList.provinceId = selectedOptions[0].value
        this.cityList.provinceName = selectedOptions[0].label
        this.cityList.cityId = selectedOptions[1] ? selectedOptions[1].value : 0
        this.cityList.cityName = selectedOptions[1] ? selectedOptions[1].label : ''
        this.cityList.countyId = selectedOptions[2] ? selectedOptions[2].value : 0
        this.cityList.countyName = selectedOptions[2] ? selectedOptions[2].label : 0
        this.defaultCityValue = [value[0], value[1], value[2]]
        this.getLogUtils().logWithTag('cityList', this.cityList)
        this.getLogUtils().logWithTag('onCityChange====domesticCityList', this.ruleForm.domesticCityList)
      } else {
        this.defaultCityValue = []
        this.cityList = {
          cityId: 0,
          cityName: '',
          countryId: 0,
          countryName: '',
          provinceId: 0,
          provinceName: '',
          countyId: 0,//区域id
          countyName: '',//区域名称
          hotId: Number(this.$route.query.hotId)
        }
      }
    },
    // 添加省市区集合
    addproProvinceCity() {
      if (this.defaultCityValue.length < 1) {
        this.$message.error('请选择国内目的地')
        return
      }
      this.getLogUtils().logWithTag('addproProvinceCity==cityList', this.cityList)
      this.getLogUtils().logWithTag('第一步domesticCityList', this.ruleForm.domesticCityList)
      let containCountyId = this.cityList.countyId ? this.cityList.countyId : 0
      let containCountyName = this.cityList.countyName ? this.cityList.countyName : ''
      let containCityId = this.cityList.cityId ? this.cityList.cityId : 0
      let containCityName = this.cityList.cityName ? this.cityList.cityName : ''
      let containProvinceId = this.cityList.provinceId ? this.cityList.provinceId : 0
      let containProvinceName = this.cityList.provinceName ? this.cityList.provinceName : ''
      let cityObj
      cityObj = {
        containCityId: containCityId,
        containCityName: containCityName,
        containCountryId: 0,
        containCountryName: '',
        containProvinceId: containProvinceId,
        containProvinceName: containProvinceName,
        containCountyId: containCountyId,//区域id
        containCountyName: containCountyName,//区域名称
        hotId: Number(this.hotId)
      }
      if (this.ruleForm.domesticCityList.length > 0) {
        let isTrue = true
        //1.如果 区域ID不是0的话，说明需要选择到区域
        let obj = this.ruleForm.domesticCityList[0]
        if (obj.containCountyId != 0) {
          //"如果 区域ID不是0的话，说明需要选择到区域"
          if (!this.cityList.cityId) {
            this.$message.error('请选择市')
            return
          }
          if (!this.cityList.countyId) {
            this.$message.error('请选择区')
            return
          }
          this.ruleForm.domesticCityList.forEach((item) => {
            if (item.containCountyId == this.cityList.countyId) {
              this.$message.error('请不要重复选择区!')
              return isTrue = false
            }
          })
        }
        //2.如果区域ID是0,省和市ID都不是0 就是到市
        if (obj.containProvinceId != 0 && obj.containCityId != 0 && obj.containCountyId == 0) {
          //"如果区域ID是0,省和市ID都不是0 就是到市"
          if (!this.cityList.cityId) {
            this.$message.error('请选择市')
            return
          }
          if (this.cityList.countyId) {
            this.$message.error('请勿选择到区')
            return
          }
          this.ruleForm.domesticCityList.forEach((item) => {
            if (item.containCityId == this.cityList.cityId) {
              this.$message.error('请不要重复选择市')
              return isTrue = false
            }
          })
        }
        //3.如果区域ID、市ID是0, 就是到省

        if (obj.containProvinceId != 0 && obj.containCityId == 0 && obj.containCountyId == 0) {
          //"如果区域ID、市ID是0, 就是到省
          if (this.cityList.cityId) {
            this.$message.error('请勿选择到市')
            return
          }
          this.ruleForm.domesticCityList.forEach((item) => {
            if (item.containProvinceId == this.cityList.provinceId) {
              this.$message.error('请不要重复选择省')
              return isTrue = false
            }
          })
        }
        if (isTrue) {
          this.ruleForm.domesticCityList.push(cityObj)
        }
      } else {
        this.ruleForm.domesticCityList.push(cityObj)
      }
      this.getLogUtils().logWithTag('domesticCityList', this.ruleForm.domesticCityList)
    },
    // 删除省内目的地
    deleteProvinceCity(item) {
      const list = this.ruleForm.domesticCityList.filter(tag => tag !== item)
      this.ruleForm.domesticCityList = list
      this.getLogUtils().logWithTag('deleteProvinceCity', this.ruleForm.domesticCityList)
    },
    filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    // 国外目的地
    onForeignCityChange(value, selectedOptions) {
      this.getLogUtils().logWithTag('onForeignCityChange---', value)
      this.getLogUtils().logWithTag('onForeignCityChange---', selectedOptions)
      if (value && value.length) {
        this.cityList.countryId = selectedOptions[0].value
        this.cityList.countryName = selectedOptions[0].label
        this.cityList.cityId = selectedOptions[1] ? selectedOptions[1].value : 0
        this.cityList.cityName = selectedOptions[1] ? selectedOptions[1].label : ''
        this.defaultForeignCityValue = [value[0], value[1]]
        this.getLogUtils().logWithTag('cityList', this.cityList)
        this.getLogUtils().logWithTag('onForeignCityChange====foreignCityList', this.ruleForm.foreignCityList)
      } else {
        this.defaultForeignCityValue = []
        this.cityList = {
          cityId: 0,
          cityName: '',
          countryId: 0,
          countryName: '',
          provinceId: 0,
          provinceName: '',
          countyId: 0,//区域id
          countyName: '',//区域名称
          hotId: Number(this.$route.query.hotId)
        }
      }
    },
    // 国外目的地
    addproForeignCity() {
      if (this.defaultForeignCityValue.length < 1) {
        this.$message.error('请选择国外目的地')
        return
      }
      this.getLogUtils().logWithTag('addproForeignCity==cityList', this.cityList)
      this.getLogUtils().logWithTag('第一步domesticCityList', this.ruleForm.domesticCityList)
      let containCityId = this.cityList.cityId ? this.cityList.cityId : 0
      let containCityName = this.cityList.cityName ? this.cityList.cityName : ''
      let containCountryId = this.cityList.countryId ? this.cityList.countryId : 0
      let containCountryName = this.cityList.countryName ? this.cityList.countryName : ''
      let cityObj
      cityObj = {
        containCityId: containCityId,
        containCityName: containCityName,
        containCountryId: containCountryId,
        containCountryName: containCountryName,
        containProvinceId: 0,
        containProvinceName: '',
        containCountyId: 0,//区域id
        containCountyName: '',//区域名称
        hotId: Number(this.hotId)
      }
      if (this.ruleForm.foreignCityList.length > 0) {
        let isTrue = true
        this.getLogUtils().logWithTag('this.ruleForm.foreignCityList', this.ruleForm.foreignCityList)
        let foreignObj = this.ruleForm.foreignCityList[0]
        if (foreignObj.containCityId != 0) {
          if (!this.cityList.cityId) {
            this.$message.error('请选择国外城市')
            return
          }
          this.ruleForm.foreignCityList.forEach((item) => {
            if (item.containCityId == cityObj.containCityId) {
              this.$message.error('请不要重复选择国外城市')
              return isTrue = false
            }
          })
        }
        if (foreignObj.containCountryId != 0 && foreignObj.containCityId == 0) {
          if (this.cityList.cityId) {
            this.$message.error('请勿选择到国外城市')
            return
          }
          this.ruleForm.foreignCityList.forEach((item) => {
            if (item.containCountryId == cityObj.containCountryId) {
              this.$message.error('请不要重复选择国家')
              return isTrue = false
            }
          })
        }
        if (isTrue) {
          this.ruleForm.foreignCityList.push(cityObj)
        }
      } else {
        this.ruleForm.foreignCityList.push(cityObj)
      }
    },
    // 删除省内目的地
    deleteCountryCity(item) {
      const list = this.ruleForm.foreignCityList.filter(tag => tag !== item)
      this.ruleForm.foreignCityList = list
      this.getLogUtils().logWithTag('deleteCountryCity', this.ruleForm.foreignCityList)
    },
    //验证图片至少一张
    checkForm() {
      if (this.ruleForm.hotWithinOrOuter == 1) {
        if (this.ruleForm.domesticCityList.length < 1) {
          this.$message.error('请至少添加一个国内目的地')
          return false
        }
      }
      if (this.ruleForm.hotWithinOrOuter == 2) {
        if (this.ruleForm.foreignCityList.length < 1) {
          this.$message.error('请至少添加一个国外目的地')
          return false
        }
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      if (this.submitFormData.hotWithinOrOuter == 1) {
        this.submitFormData.foreignCityList = []
      } else {
        this.submitFormData.domesticCityList = []
      }
      this.getHttpServices().getUserService().post('user/shopDestination/editShopDestinationDetails', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('目的地保存成功')
        this.$router.push({
          name: 'DestinationList',
          query: {
            updateFlag: true
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取详情
    getDesDetails() {
      if (this.hotId != 0) {
        this.getHttpServices().getUserService().get('user/shopDestination/getShopDestinationDetails?hotId=' + this.hotId).then(res => {
          this.getLogUtils().logWithTag('getDesDetails', res)
          this.ruleForm = res
          if (this.ruleForm.hotWithinOrOuter == 1) {
            this.ruleForm.foreignCityList = []
          } else {
            this.ruleForm.domesticCityList = []
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.ruleForm = {
          hotDestinationName: '',
          hotIsHotPush: 1,//是否热推 0普通 1热推 ,
          hotWithinOrOuter: 1,//1 国内 2 国外
          hotId: this.$route.query.hotId,
          foreignCityList: [],//国家城市集合
          domesticCityList: [],//省市城市集合
          hotSort: '',//排序
          hotStatus: 1
        }
        this.defaultCityValue = []
        this.defaultForeignCityValue = []
        this.cityList = {
          cityId: 0,
          cityName: '',
          countryId: 0,
          countryName: '',
          provinceId: 0,
          provinceName: '',
          countyId: 0,//区域id
          countyName: '',//区域名称
          hotId: Number(this.$route.query.hotId)
        }
      }

    }
  }

}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.page {
  padding-top: 10px;
  background-color: #FFFFFF;
  height: 100%;

  .tabs-list {
    height: 40px;
    line-height: 40px;

    .tabs {
      margin-right: 10px;
      border: 1px solid #d9d9d9;
      background: #fafafa;
      padding: 0 7px;
      border-radius: 4px;
    }
  }

}

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.pl10 {
  padding-left: 10px;
}

.ant-btn + .ant-btn {
  margin-left: 10px;
}
</style>